<vdw-dialog-button
  #datePicker
  [componentType]="JUMP_TO_DATE_PICKER_CALENDAR"
  [dialogData]="{selectedDate}"
  [dialogClass]="['bms-theme', 'no-border', 'no-padding']"
  [dialogAutoHeight]="true"
  [verticaloffset]="8"
  [horizontalOffset]="-12"
  [align]="'left'"
  (dialogDataChanged)="selectedDateChanged($event)"
>
  <div class="flex-row flex-center gap-4 font-weight-regular" (click)="datePicker.toggleDialog()">
    {{ 'CALENDAR.SCHEDULE.JUMP_TO' | bmsTranslate }}
    <mat-icon class="icon-16" svgIcon="solid-keyboard-arrow-down"></mat-icon>
  </div>
</vdw-dialog-button>
